const checkNotificationStatus = (currentStatus, requiredStatus) => {
    return currentStatus === requiredStatus
}

const isNotificationDelivered = (status) =>
    checkNotificationStatus(status, 'delivered')

const isNotificationNotDelivered = (status) =>
    checkNotificationStatus(status, 'undelivered')

const isNotificationUnsent = (status) =>
    checkNotificationStatus(status, 'unsent')

export {
    checkNotificationStatus,
    isNotificationDelivered,
    isNotificationNotDelivered,
    isNotificationUnsent,
}
